import { FooterLink, LinkProps } from './footer-link';

interface ColumnProps {
  title: string;
  links: LinkProps[];
}

export const FooterColumn: React.FC<ColumnProps> = ({ title, links }) => (
  <ul>
    <li className={'md:block mb-4 hidden'}>
      <div
        className={
          'mf-link mf-link--site-montefiore mf-link--primary mf-link--base mf-link--no-underline font-bold'
        }
        data-analytics-click-text={title}
        data-analytics-link-type={'link'}
      >
        <span className={'mf-link__text'}>
          <span className={'mf-link__text__inner'}>{title}</span>
        </span>
      </div>
    </li>
    {links.map((link, index) => (
      <li className={'md:block mb-2 hidden last:mb-0'} key={index}>
        <FooterLink
          href={link.href}
          text={link.text}
          analyticsText={link.analyticsText}
        />
      </li>
    ))}
  </ul>
);
